import { getCookieByName } from '~/utilities/data/getCookieByName';

/**
 * Initializes the session ID cookie with a lifespan of 30 minutes.
 * If a cookie named 'mm-session-id' already exists, it updates its expiry time.
 * Otherwise, it creates a new session ID cookie with a unique value.
 */
export const initSessionId = () => {
  const thirtyMinutes = 30 * 60;
  const sessionId = getCookieByName('mm-session-id');

  if (sessionId) {
    document.cookie = `mm-session-id=${sessionId}; max-age=${thirtyMinutes}; path=/`;
  } else {
    const newSessionId = Date.now().toString(36) + Math.random().toString(36);

    document.cookie = `mm-session-id=${newSessionId}; max-age=${thirtyMinutes}; path=/`;
  }
};
